/**
 * Shared page toolbar: info cluster left, actions cluster right.
 * Used by WorkspacesPage and WorkspacePage so the launch → in-workspace
 * transition keeps one consistent bar (consistency by construction).
 */

import type { ReactElement, ReactNode } from 'react';

interface ToolbarProps {
  info: ReactNode;
  actions?: ReactNode;
}

export function Toolbar({ info, actions }: ToolbarProps): ReactElement {
  return (
    <div className="app-toolbar" role="toolbar" aria-label="Workspace controls">
      <div className="app-toolbar__info">{info}</div>
      {actions != null && <div className="app-toolbar__actions">{actions}</div>}
    </div>
  );
}
